var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    attrs: {
      id: "application-flow-modal",
      "loaders-disabled": "",
      "footer-close-button-text": _vm.$t("application-flow.modal.cancel"),
    },
    on: {
      hidden: function ($event) {
        return _vm.$emit("hidden")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " + _vm._s(_vm.$t("application-flow.modal.title")) + "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm._v(
              "\n    " + _vm._s(_vm.$t("application-flow.modal.body")) + "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "simple-button",
              {
                attrs: { type: "danger" },
                on: { click: _vm.handleConfirmClick },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("application-flow.modal.proceed")) +
                    "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }